import { render, staticRenderFns } from "./TaskStageTabs.vue?vue&type=template&id=feddd5cc"
import script from "./TaskStageTabs.vue?vue&type=script&lang=js"
export * from "./TaskStageTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports